import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-models',
  templateUrl: './dialog-models.component.html',
  styleUrls: ['./dialog-models.component.scss'],
})
export class DialogModelsComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
